import { jsxs as p, jsx as o } from "react/jsx-runtime";
import { forwardRef as d, useCallback as u } from "react";
import e from "./styles.module.less.js";
import f from "./clock.svg.js";
const g = d((r, s) => {
  var n;
  const { value: m, disabled: a, onChange: t, error: i } = r, l = u((c) => {
    a || t(c.target.value);
  }, [a, t]);
  return /* @__PURE__ */ p("div", { className: e.timeInputWrapper, children: [
    /* @__PURE__ */ o(
      "input",
      {
        ref: s,
        ...r.props,
        className: `${e.timeInput} ${(n = r.props) == null ? void 0 : n.className} ${i ? e.error : ""}`,
        type: "time",
        value: m,
        onChange: l,
        disabled: a
      }
    ),
    /* @__PURE__ */ o("div", { className: e.clockIcon, children: /* @__PURE__ */ o(f, {}) })
  ] });
});
g.displayName = "TimeInput";
export {
  g as TimeInput
};
